// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"654":"da0d37e5","715":"323fede9","760":"52b70ca1"}[chunkId] + ".chunk.css";
};